import React from 'react'
import { Link } from 'react-router-dom'
import { FormFooterProps } from '../types'

const FormFooter: React.FC<FormFooterProps> = ({ isRegister }) => {
  return (
    <p className="mt-7 lg:mt-9 text-sm lg:text-lg font-light text-secondaryNeutralAlpha-11 text-opacity-[62.75%]">
        {isRegister 
        ? "Already have an account? "
        : "Don't have an account? "}
        <Link to={isRegister ? "/auth/login" : "/auth/register"} className="text-primaryAccent-9 font-normal lg:font-medium underline underline-offset-auto">
            {isRegister ? "Log in" : "Sign up"}
        </Link>
    </p>
  )
}

export default FormFooter
